import { DynamicIcon } from 'src/components';

/** DatePicker `slots.openPickerIcon` needs a component reference. */
export const LucideCalendarPickerIcon = () => (
  <DynamicIcon
    name="calendar"
    library="lucide"
    size={21}
    sx={{ color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant }}
  />
);
